import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Clock } from 'lucide-react'
import { navigation, contactInfo } from '../../data'

export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-6">
              {/*  <div className="w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">S</span>
              </div> */}
              <div className="w-10 h-10 flex items-center justify-center">
                <img src="/logo.png" alt="logo" className="w-8 h-8 rounded-full" />
              </div>
              <span className="font-bold text-xl">书香云库</span>
            </div>
            <p className="text-gray-400 mb-6">
              专注于学校食堂供应链管理，为学校提供安全、高效、透明的供应链解决方案，让食材供应、学校出入库、财务结算、教育管理综合监督提质增优。
            </p>
            {/* <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300">
                <MessageCircle className="w-6 h-6" />
              </a>
            </div> */}
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">快速链接</h3>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.id}>
                  <Link
                    onClick={scrollToTop}
                    to={item.href}
                    className="text-gray-400 hover:text-white transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6">联系方式</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">{contactInfo.phone}</span>
              </li>
              {contactInfo.email && (
                <li className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-400">{contactInfo.email}</span>
                </li>
              )}
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">{contactInfo.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">{contactInfo.workingHours}</span>
              </li>
            </ul>
          </div>

          {/* <div>
            <h3 className="text-lg font-semibold mb-6">关注我们</h3>
            <div className="bg-gray-800 p-4 rounded-lg inline-block">
              <div className="w-32 h-32 bg-white rounded flex items-center justify-center">
                <span className="text-gray-400 text-sm">微信公众号二维码</span>
              </div>
            </div>
            <p className="text-gray-400 mt-4 text-sm">
              扫码关注公众号，获取最新资讯
            </p>
          </div> */}
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500 text-sm">
          <p>© {new Date().getFullYear()} 曲靖宇诚科技有限公司. 保留所有权利.</p>
        </div>
      </div>
    </footer>
  )
}
